import {QueryParam, SessionStorageKey} from 'common/types';
import React, {FunctionComponent} from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, RouteProps} from 'react-router-dom';
import {AppState} from 'store';
import * as UserSelectors from 'store/user/selectors';
import Loading from 'screens/common/Loading';
import {createLoginLink} from 'utils/navigation';

const mapStateToProps = (state: AppState) => ({
  user: UserSelectors.userInfo(state),
  isUserActual: UserSelectors.isUserInfoActual(state),
  isUserFetching: UserSelectors.isUserInfoFetching(state),
  error: UserSelectors.userInfoError(state),
});

interface PrivateRouteProps
  extends RouteProps,
    ReturnType<typeof mapStateToProps> {
  requireIbanEligibility?: boolean;
}

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({
  component: Component,
  isUserActual,
  isUserFetching,
  user,
  error,
  requireIbanEligibility = false,
  ...props
}: PrivateRouteProps) => {
  return (
    <Route
      {...props}
      render={componentProps => {
        if (!user && (isUserActual || error)) {
          const to = props.location
            ? props.location.pathname + props.location.search
            : undefined;

          const redirectUrl = createLoginLink({[QueryParam.To]: to});

          return <Redirect to={redirectUrl} />;
        }

        if (user) {
          if (user.infoComplete === false) {
            return <Loading />;
          }

          if (requireIbanEligibility && !user.isFopIbanEligible) {
            return <Redirect to="/profile/edit" />;
          }

          // @ts-ignore
          return <Component {...componentProps} />;
        }

        return null;
      }}
    />
  );
};

const ConnectedPrivateRoute = connect(mapStateToProps)(PrivateRoute);

export default ConnectedPrivateRoute;
